import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import '../styles/Footer.css';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="app-footer">
      <Container>
        <Row className="gy-4">
          <Col lg={4} md={6}>
            <div className="footer-section">
              <div className="footer-brand">
                <img
                  src="/img/logo-agricampanha.png"
                  alt="Agricampanha Logo"
                  className="footer-logo"
                  loading="lazy"
                />
              </div>
              <span className="footer-tagline">Sempre ao lado do produtor</span>
              <p>
                Associação dos Agricultores da Região da Campanha,
                representando e fortalecendo os produtores rurais de Bagé/RS.
              </p>
            </div>
          </Col>

          <Col lg={2} md={6}>
            <div className="footer-section">
              <h5 className="footer-title">Institucional</h5>
              <ul className="footer-links">
                <li><Link to="/">Início</Link></li>
                <li><Link to="/quem-somos">Quem Somos</Link></li>
                <li><Link to="/projetos">Projetos</Link></li>
                <li><Link to="/#contato">Contato</Link></li>
              </ul>
            </div>
          </Col>

          <Col lg={2} md={6}>
            <div className="footer-section">
              <h5 className="footer-title">Atualizações</h5>
              <ul className="footer-links">
                <li><Link to="/noticias">Notícias</Link></li>
                <li><Link to="/#cotacoes">Cotações</Link></li>
                <li><Link to="/#previsao">Previsão do Tempo</Link></li>
              </ul>
            </div>
          </Col>

          <Col lg={3} md={6}>
            <div className="footer-section">
              <h5 className="footer-title">Contato</h5>
              <ul className="footer-contact">
                <li>
                  <i className="bi bi-geo-alt"></i>
                  <span>Rua Hipólito Ribeiro, 400<br />Centro, Bagé/RS<br />CEP 96400-430</span>
                </li>
                <li>
                  <i className="bi bi-envelope"></i>
                  <a href="mailto:agricampanha@gmail.com">agricampanha@gmail.com</a>
                </li>
              </ul>
              <div className="footer-social">
                <a href="https://www.instagram.com/agri.campanha/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                  <i className="bi bi-instagram"></i>
                </a>
                <a href="https://www.facebook.com/agricampanha" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                  <i className="bi bi-facebook"></i>
                </a>
                <a href="mailto:agricampanha@gmail.com" aria-label="Email">
                  <i className="bi bi-envelope"></i>
                </a>
              </div>
            </div>
          </Col>
        </Row>

        <hr className="footer-divider" />

        <Row>
          <Col className="text-center">
            <p className="footer-copyright">
              &copy; {currentYear} Agricampanha. Todos os direitos reservados.
            </p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
